import { render, staticRenderFns } from "./PageBarquettage.vue?vue&type=template&id=4217fda6&"
import script from "./PageBarquettage.vue?vue&type=script&lang=js&"
export * from "./PageBarquettage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4217fda6')) {
      api.createRecord('4217fda6', component.options)
    } else {
      api.reload('4217fda6', component.options)
    }
    module.hot.accept("./PageBarquettage.vue?vue&type=template&id=4217fda6&", function () {
      api.rerender('4217fda6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/PageBarquettage.vue"
export default component.exports